// SearchAndFilter.tsx
import React, { Dispatch, SetStateAction } from "react";
import CustomButton from "../../UI/Buttons/CustomButton";
import Download from "../../UI/Icons/Download";
import Search from "../../UI/Icons/Search";
import Checkbox from "../../UI/Inputs/Checkbox";

interface SearchAndFilterProps {
  keyword: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onExportCSV: () => void;
  selectCandidatesCompletedCheckbox: boolean;
  setSelectCandidatesCompletedCheckbox: Dispatch<SetStateAction<boolean>>
}

const SearchAndFilter: React.FC<SearchAndFilterProps> = ({
  keyword,
  onSearchChange,
  onExportCSV,
  selectCandidatesCompletedCheckbox,
  setSelectCandidatesCompletedCheckbox
}) => {
  
  const handleCheckBox = (checked: boolean) => {
    setSelectCandidatesCompletedCheckbox(checked ? true : false)
  }
  
  return (
    <>
      <div className="d-flex flex-column flex-lg-row gap-20 align-items-lg-center justify-content-lg-between">
        <div className="form-group w-200px mobile-w-100 input-icon icon-left">
          <Search />
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            value={keyword}
            onChange={onSearchChange}
          />
        </div>
        <div className="d-flex flex-column flex-lg-row gap-25 align-items-lg-center">
          <div className="theme-check">
            <Checkbox
              className="theme-check-input"
              id="worked_at_previously"
              checked={selectCandidatesCompletedCheckbox}
              onChange={handleCheckBox}
              labelFontSize={"13"}
              label={"Only Referees Who Have Completed a Job"}
              themeCheck={true}
            />
          </div>
          <div className="d-flex">
            <CustomButton
              variant="primary"
              className="btn-theme bg-white text-black"
              onClick={onExportCSV}
            >
              <Download />
              Export CSV Report
            </CustomButton>
          </div>
        </div>
      </div>
    </>
  )
};

export default SearchAndFilter;
